if(typeof _GIRL_CONF['winona']['game_memory']=='undefined'){_GIRL_CONF['winona']['game_memory']={};};
_GIRL_CONF['winona']['game_memory']['face']={left:600,top:142,width:122,height:159};
_GIRL_CONF['winona']['game_memory']['hair']={left:511,top:65,width:270,height:288};
_GIRL_CONF['winona']['game_memory']['hand1']={left:519,top:268,width:115,height:270};
_GIRL_CONF['winona']['game_memory']['hand2']={left:510,top:468,width:268,height:213};
_GIRL_CONF['winona']['game_memory']['item1']={left:233,top:263,width:228,height:438};
_GIRL_CONF['winona']['game_memory']['item2']={left:820,top:408,width:146,height:293};
_GIRL_CONF['winona']['game_memory']['tit1']={left:673,top:369,width:105,height:137};
_GIRL_CONF['winona']['game_memory']['tit2']={left:587,top:370,width:98,height:139};
